<template v-if="currentDepartment">
    <li class="main-header__inner__left__wrap__nav__item">
        <router-link
            :to="{ name: 'employ-certificate' }"
            active-class="active"
            class="main-header__inner__left__wrap__nav__item__link"
            title="Alla certifikat"
        >
            Alla certifikat
        </router-link>
    </li>
    <li class="main-header__inner__left__wrap__nav__item">
        <router-link
            :to="{ name: 'employ-create-certificate' }"
            active-class="active"
            class="main-header__inner__left__wrap__nav__item__link"
            title="Skapa nya certifikat manuellt eller via fil"
        >
            Utfärda certifikat
        </router-link>
    </li>
    <li class="main-header__inner__left__wrap__nav__item">
        <router-link
            :to="{ name: 'employ-competences' }"
            active-class="active"
            class="main-header__inner__left__wrap__nav__item__link"
            title="Hantera kompetense"
        >
            Kompetenser
        </router-link>
    </li>
    <li class="main-header__inner__left__wrap__nav__item">
        <router-link
            :to="{ name: 'employ-employees' }"
            active-class="active"
            class="main-header__inner__left__wrap__nav__item__link"
            title="Se och hantera dina medarbetare och roller"
        >
            Organisation
        </router-link>
    </li>
</template>
